import React, { useState, useRef, useEffect } from 'react';
import ReactModal from 'react-modal';
import { useMediaQuery } from 'react-responsive';
import data from '../../data/data';
import settings from '../../data/settings';
import MenuContentOnePage from '../MenuContentOnePage/MenuContentOnePage';
import MenuContentMultipage from '../MenuContentMultipage/MenuContentMultipage';
import MenuContentOnePageAllOpen from '../MenuContentOnePageAllOpen/MenuContentOnePageAllOpen';
import CloseButton from '../CloseButton/CloseButton';

const MenuRight = ({
  isOpen,
  onRequestClose,
  onClick,
  setIsOpen,
  setIsClose,
}) => {
  const isSmallScreen = useMediaQuery({ maxWidth: 640 });
  const isMediumScreen = useMediaQuery({ minWidth: 641, maxWidth: 1023 });
  const [bgColor, setBgColor] = useState('');
  const [menuBackgroundColor, setMenuBackgroundColor] = useState('#fff');
  const [isButtonAnimated, setIsButtonAnimated] = useState(false);

  const setBackgroundColor = () => {
    setTimeout(() => {
      setBgColor('rgba(0, 0, 0, 0.3)');
    }, 500);
  };

  useEffect(() => {
    isOpen ? setBackgroundColor() : closeMenu();
  }, [isOpen]);

  const closeMenu = () => {
    setBgColor('transparent');
  };

  useEffect(() => {
    setMenuBackgroundColor(settings.colors.navigation_background_color);
  }, []);

  const setTransition = () => {
    setTimeout(() => {
      return 'translateX(0)';
    }, 500);
  };

  useEffect(() => {
    setTimeout(() => {
      const modalContent = document.querySelector('.ReactModal__Content');
      if (isOpen && modalContent) {
        modalContent.classList.add('viergrad-menu');
      } else if (modalContent) {
        modalContent.classList.remove('viergrad-menu');
      }
    }, 0); // A added a small timeout so there is time to add a class .viergrad-menu
  }, [isOpen]);

  const modalStyle = {
    overlay: {
      position: 'fixed',
      transition: '0.5s ease-out, transform 0.25s ease-out',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: `${bgColor}`,
      zIndex: 1,
    },
    content: {
      top: 0,
      left: isOpen ? 0 : 'auto', // Menjamo položaj levog ivice na 0 kada je otvoren
      right: 0,
      bottom: 0,
      transition: '0.5s ease-out, transform 0.25s ease-out',

      transform: isOpen ? 'translateX(0)' : 'translateX(100%)', // Pomera se sa desne na levu
      width: `${isSmallScreen ? '100%' : isMediumScreen ? '480px' : '600px'}`,
      marginLeft: 'auto',
      border: 'none',
      background: `${menuBackgroundColor}`,
      overflow: 'auto',
      WebkitOverflowScrolling: 'touch',
      borderRadius: '4px',
      outline: 'none',
      paddingTop: 20,
      paddingLeft: 0,
      paddingBottom: 0,
      paddingRight: 0,
    },
  };

  useEffect(() => {
    setMenuBackgroundColor(settings.colors.navigation_background_color);
    setIsButtonAnimated(settings.animated_menu_button);
  }, []);

  return (
    <div>
      {isButtonAnimated ? (
        <CloseButton
          isOpen={isOpen}
          toggleMenu={isOpen ? setIsClose : setIsOpen}
          onRequestClose={onRequestClose}
        />
      ) : null}
      <div className='d-flex'>
        <ReactModal
          style={modalStyle}
          isOpen={isOpen}
          onRequestClose={onRequestClose}
          closeTimeoutMS={500}
          ariaHideApp={false}
        >
          {settings.menu_structure === 'multi_page' ? (
            <MenuContentMultipage
              onClick={onClick}
              isOpen={isOpen}
              setIsOpen={setIsOpen}
            />
          ) : settings.menu_structure === 'single_page' ? (
            <MenuContentOnePage
              onClick={onClick}
              isOpen={isOpen}
              setIsOpen={setIsOpen}
            />
          ) : (
            <MenuContentOnePageAllOpen
              onClick={onClick}
              isOpen={isOpen}
              setIsOpen={setIsOpen}
            />
          )}
        </ReactModal>
      </div>
    </div>
  );
};

export default MenuRight;
